import { memo as Memo, useMemo } from 'react';

//* Components
import Text from 'components/common/Text';
import Image from 'components/common/Image';
import CategoriesHorizontalSlider from '../CategoriesHorizontalSlider';

//* Styles
import CategoryNavbarStyle from './style';
import { useLanguageContext, withLanguageContext } from 'context';

const CategoryNavbar = Memo(({ active, categories, top_destinations, selectCategory, selectInfo, selectedLang }) => {
	//! Top destinations HTML
	const topDestinationsHTML = useMemo(() => {
		return (
			<CategoriesHorizontalSlider className={`top-destination`}>
				{top_destinations.map((i, k) => {
					return (
						<div
							onClick={() => selectInfo(i)}
							className='dest-inner-cont'
							key={k}
						>
							<Image
								objectFit={'cover'}
								src={i.featured_image?.url}
								alt={i.featured_image?.alt}
							/>
							<Text
								text={i.name}
								className={`dest-slide-title font-ping-medium p pXS`}
							/>
						</div>
					);
				})}
			</CategoriesHorizontalSlider>
		);
	}, [top_destinations]);

	return (
		<CategoryNavbarStyle className={active ? 'active' : 'active hide-scrollbar'}>
			<div className='cat-container'>
				<Text
					text={'chooseTheCategory'}
					className='cat-sec-title h6 font-ping-bold'
				/>

				<div className='cats-container'>
					{categories.map((cat, k) => {
						return (
							<div
								className='cat'
								key={k}
							>
								<div
									onClick={() => selectCategory(cat)}
									className={`cat-inner-cont secondaryColor4-bg bg${cat.color}-hover`}
								>
									<div className={`cat-image-cont`}>
										<Image
											className='cat-image'
											src={cat.icon.url}
											alt={cat.icon.alt}
										/>
										<Image
											className='cat-hover-image'
											src={cat.icon_hover?.url}
											alt={cat.icon_hover?.alt}
										/>
									</div>

									<Text
										text={cat.name}
										className={`cat-title font-ping-bold p ${selectedLang == 'hy' ? 'pXXS' : 'pXS'}`}
									/>
								</div>
							</div>
						);
					})}
				</div>
			</div>

			<div className='top-dest-cont'>
				<Text
					text={'topDestinations'}
					className='cat-sec-title h6 font-ping-bold'
				/>

				{topDestinationsHTML}
			</div>
		</CategoryNavbarStyle>
	);
});

export default withLanguageContext(CategoryNavbar, ['selectedLang']);
